module.exports = __webpack_public_path__ + "img/guide-2.f3e071ef.png";